import { useAuth } from '@frontegg/react';
import { useQuery } from '@tanstack/react-query';
import { ACCOUNT } from '../constants/queryKeys';
import { fetchAccount } from '../services/api';
import { isInSaaSMode } from '../utils/common';

const useAccount = () => {
  const authHook = isInSaaSMode() ? useAuth : null;
  const { isAuthenticated } = authHook?.() || {};
  const { data, isLoading, isInitialLoading, isFetched, isError } = useQuery(
    [ACCOUNT],
    fetchAccount,
    {
      enabled: isAuthenticated,
    },
  );

  return {
    data,
    isLoading,
    // True only during a real in-flight first fetch; false when the query is
    // disabled (unlike isLoading, which stays true for disabled queries in v4).
    isInitialLoading,
    isFetched,
    isError,
  };
};

export default useAccount;
